<template>
  <el-main
      v-loading.fullscreen="loading"
      style="padding: 0"
      element-loading-text="打印页加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.7)">
    <div v-for="(item, index) in printList" :key="index">
      <k-z-g-inspection-print-content :inspection-record="item"/>
    </div>
  </el-main>
</template>

<script>
  import KZGInspectionPrintContent from "@/views/purchase/kzgReport/KZGInspectionPrintContent";

  export default {
    name: "FactoryInspectionMultiPrintPage",
    components: {KZGInspectionPrintContent},
    data() {
      return {
        ids: this.$route.query.items,
        printList: [],
        loading: false,
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList() {
        this.loading = true;
        let param = JSON.parse(this.ids);
        this.$http.post("basic","scanRecords/batch", param).then(res => {
          this.printList = res;
          console.log(this.printList);
          this.$nextTick(() => {
            setTimeout(() => {
              window.print();
              window.close();
            }, 1000);
          });
        }).catch(() => {
          this.$message.error("获取列表失败");
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
